var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.73142 8.46156L15.7209 2.47209C16.093 2.10029 16.093 1.49702 15.7209 1.12522C15.3488 0.7531 14.7461 0.7531 14.374 1.12522L8.38455 7.11469L2.39476 1.12522C2.02264 0.7531 1.42001 0.7531 1.04789 1.12522C0.675769 1.49702 0.675769 2.10029 1.04789 2.47209L7.03768 8.46156L1.04789 14.451C0.675769 14.8228 0.675769 15.4261 1.04789 15.7979C1.23395 15.9836 1.47779 16.0767 1.72132 16.0767C1.96485 16.0767 2.2087 15.9836 2.39476 15.7976L8.38455 9.80812L14.374 15.7976C14.5601 15.9836 14.8039 16.0767 15.0475 16.0767C15.291 16.0767 15.5348 15.9836 15.7209 15.7976C16.093 15.4258 16.093 14.8225 15.7209 14.4507L9.73142 8.46156Z",
    fill: "#717171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBtn);
export default __webpack_public_path__ + "static/media/cross_btn.4ebb6a1e2939073e7de5f7d32c0dba05.svg";
export { ForwardRef as ReactComponent };